module.exports = __webpack_public_path__ + "img/ellipse.dbbfd85a.svg";